var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section is-main-section"},[_c('div',[_c('p',[_vm._v("Non esistono permessi di accesso o autenticazione fallita.")])])])}]

export { render, staticRenderFns }